<template>
	<div>
		<c-dialog ref="dialog" width="650" mask-close @close="dialogFormEditConfirm($refs.outputForm, arguments)" @resolve="editHandle">
			<c-form ref="outputForm" unit-width="100%">
				<c-form-item label="工单编号">
					<c-select name="work_id" async :value-data="workOptions" disabled :clear="false">
						<template #option="{data, selected}">
							<select-option
								:name="data.name"
								:info="[
									textJoin(data.data.product_code, data.data.product_name, data.data.product_spec)
								]"
								:selected="selected"
							></select-option>
						</template>
					</c-select>
					<info-card code="WORK_PRODUCT" :id="work_id"></info-card>
				</c-form-item>
				<c-form-item label="工序">
					<c-select name="task_id" :options="taskOptions" disabled :clear="false"></c-select>
				</c-form-item>
				<c-form-item label="生产人员">
					<c-select name="output_user_id" async :value-data="outputUserOptions" disabled :clear="false"></c-select>
				</c-form-item>
				<c-form-item label="良品数" name="counts">
					<c-input type="number" name="aux_fine_count" decimal="6" :range="[0,99999999]" v-model="aux_fine_count" disabled :append-text="aux_unit"></c-input> 
				</c-form-item>
				<c-form-item label="不良品数" name="counts" v-show="systemConfig.defects_salary && systemConfig.defects_salary == '1'">
					<c-input type="number" name="aux_defects_count" decimal="6" :range="[0,99999999]" v-model="aux_defects_count" disabled  :append-text="aux_unit"></c-input> 
				</c-form-item>
				<c-form-item label="计价方式" required>
					<c-radio-group name="pricing_type" :options="pricingTypeDic" v-model="pricing_type" ></c-radio-group>
				</c-form-item>
				<c-form-item label="报工时长" v-show="pricing_type == 2" required>
					<c-grid-row gap column="2">
						<c-grid-col>
						<c-input type="stepper" stepControls="side" name="duration_hours" :range="[0,262800]" append-text="小时" :clear="false" v-model="duration_hours" @change="changeHoursMinutes"></c-input>
						</c-grid-col>
						<c-grid-col>
						<c-input type="stepper" stepControls="side" name="duration_minutes" :range="[0,59]" append-text="分钟" :clear="false" v-model="duration_minutes" @change="changeHoursMinutes"></c-input>
						</c-grid-col>
					</c-grid-row>
				</c-form-item>
				<c-form-item label="报工时间" v-show="pricing_type == 2" required>
					<c-datetime start-name="real_start_date" end-name="real_end_date" type="datetime" range time-accuracy="min" :clear="false" format="yyyy-MM-dd hh:mm" v-model="real_date" @change="changeRealDate"></c-datetime>
				</c-form-item>
				<c-form-item label="工资单价">
					<c-input type="number" name="price" decimal="6" :range="[0,99999999]" v-model="price" append-text="元" @change="changePrice"></c-input>
					<template #handle>
						<c-refresh class="flex-center" color="main" @click="getOutputPriceConfig()"></c-refresh>
					</template>
				</c-form-item>
				<c-form-item label="预计工资">
					<c-input type="number" name="pre_salary" decimal="6" :range="[0,99999999]" v-model="pre_salary" append-text="元"></c-input>
				</c-form-item>
			</c-form>
		</c-dialog>
	</div>
</template>

<script>
import {mapState} from "vuex";

export default {
	data() {
		return {
			work_id:0,
			task_id:0,
			process_id:0,
			output_id: 0,
			workOptions:[],
			taskOptions: [],
			outputUserOptions: [],
			duration_minutes:0,
			duration_hours:0,
			real_date:[],
			price:0,
			pre_salary:0,
			aux_fine_count:0,		//产品良品数
			aux_defects_count:0,	//产品不良品数
			output_user_id:0, //报工人
			pricing_type:1, //计价方式（1：计件，2：计时）
			
			aux_unit:'',
		}
	},

	computed: {
		// 获取dictName选项数据
		...mapState(['userInfo', 'systemConfig', 'pricingTypeDic', 'outputTypeDic']),
	},
	
	methods: {
		//输入报工时长小时、分钟
		changeHoursMinutes(){
			var currentTime = new Date(this.real_date[1]);
			var real_start_date = new Date(currentTime.getTime() - (this.duration_hours * 60 * 60 * 1000) - (this.duration_minutes * 60 * 1000)).format('yyyy-MM-dd hh:mm');
			var real_end_date = new Date(currentTime).format('yyyy-MM-dd hh:mm');
			this.real_date = [real_start_date, real_end_date];
		},
		
		//报工时间选择
		changeRealDate(data){
			const start = new Date(data[0]);
			const end = new Date(data[1]);
			const difference = end - start; // 时间差，单位毫秒
			// 转换为小时和分钟
			const hours = Math.floor(difference / 3600000);
			const minutes = Math.floor((difference % 3600000) / 60000)
			this.duration_hours = hours;
			this.duration_minutes = minutes;
		},
		
		//变更单价
		changePrice(){
			if(this.pricing_type == 1){//计件
				if(this.systemConfig.defects_salary && this.systemConfig.defects_salary == '1'){
					this.pre_salary = parseFloat((parseFloat(this.price)*(parseFloat(this.aux_fine_count || 0)+parseFloat(this.aux_defects_count || 0))).toFixed(2));
				}else{
					this.pre_salary = parseFloat((parseFloat(this.price)*parseFloat(this.aux_fine_count || 0)).toFixed(2));
				}
				
			}else {//计时
				var time =  parseFloat(this.duration_hours||0) + (parseFloat(this.duration_minutes||0) / 60);
				this.pre_salary = parseFloat((parseFloat(this.price)*time).toFixed(2));
			}
		},
		
		/************打开新增/编辑报工弹窗**************/
		open(data) {
			this.$refs.outputForm.clear();
			this.output_id = data.id;
			this.getDetail();
			this.$refs.dialog.open({
				title: '编辑报工工资'
			});
		},
		
		/*******搜索报工详情*******************/
		getDetail() {
			this.request({
				url:'/output/detail',
				data: {
					id: this.output_id
				},
				loading: true,
				success: data => {
					data.detailInfo.product_spec = data.detailInfo.product_spec||'-'
					//工单基本信息
					this.$refs.outputForm.set(data.detailInfo);
					
					//工单ID
					this.work_id = data.taskInfo.work_id;
					//任务ID
					this.task_id = data.taskInfo.id;
					//工序ID
					this.process_id = data.taskInfo.process_id;
					//报工人ID
					this.output_user_id = data.detailInfo.output_user_id;
					//报工类型（1：正常报工，2：返工报工）
					this.output_type = data.detailInfo.output_type;
					//返工类型（1：正常返工，2：报废返工）
					this.rework_after_type = data.detailInfo.rework_after_type;
					
					//处理选中工单信息
					this.workOptions = [{
						name: data.taskInfo.work_code,
						value: data.taskInfo.work_id
					}];
					
					//处理已选中的不良品项
					var selectDefectsDatas = data.defectsList.map(item => {
						return item.id
					});
					
					// //处理可选任务工序下拉数据
					this.taskOptions = [{
						name: data.taskInfo.process_code +'  |  ' +data.taskInfo.process_name,
						value: data.detailInfo.task_id
					}];
					
					//处理选中员工信息
					this.outputUserOptions = [{
						name: data.detailInfo.output_user_realname,
						value: data.detailInfo.output_user_id
					}];

					this.aux_unit = data.detailInfo.aux_unit;
					//自定义字段
					this.custom_fields_value_json = data.detailInfo.custom_fields_value_json;
				}
			});
		},
		
		/*******提交编辑数据********************/
		editHandle(stop, next) {
			stop();
			this.$refs.outputForm.submit({
				url: '/output/editPrice',
				rule: {
					price: '请输入报工工价',
					pre_salary: '请输入工资',
					pricing_type:'请选择计价方式',
					duration_hours: '请输入报工时长',
					duration_minutes: '请输入报工时长',
				},
			    dataFormatter: data => {
					data.id = this.output_id || 0;
					return data;
				},
				success: (data, res) => {
					next();
					this.$message({
						type: 'success',
						message:'编辑报工工资成功',
					});
					//刷新页面
					this.$emit('resolve');
				}
			})
		},
		
		/********获取报工工资信息*************/
		getOutputPriceConfig(){
			this.$nextTick(() => {
				this.price = 0;
				if (this.work_id
					&& this.process_id
					&& this.task_id
					&& this.pricing_type
					&& this.output_user_id
				){
					this.request({
						url: '/output/price/config',
						data: {
                            output_id:this.output_id,
							work_id:this.work_id,
							process_id:this.process_id,
							task_id:this.task_id,
							pricing_type:this.pricing_type,
							output_user_id:this.output_user_id,
                            aux_fine_count:this.aux_fine_count,
                            aux_defects_count:this.aux_defects_count,
							output_type:this.output_type||1,
							rework_after_type:this.rework_after_type||0,
							custom_fields_value_json: JSON.stringify(this.custom_fields_value_json)
						},
						loading: true,
						success: data => {
							this.$refs.outputForm.set({
								price: data.price||0,
								pre_salary: data.pre_salary||0
							});
						}
					});
				}
			});
		}
	}
}
</script>
<style lang="stylus" scoped>
</style>